// src/pages/Workflows/Execucoes/index.js — Tela 3: Execuções de um Workflow

import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

import { useWorkflowExecucoes } from './hooks/useWorkflowExecucoes';
import ExecucoesList from './components/ExecucoesList';
import ExecucaoLogItem from './components/ExecucaoLogItem';
import ExecucaoDetalhe from './components/ExecucaoDetalhe';
import ExecutarModal from '../components/ExecutarModal/ExecutarModal';

import '../Workflows.css';
import './Execucoes.css';

export default function WorkflowExecucoes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdminUser = user?.isAdmin === true || user?.role === 'admin';

  const {
    execucoes,
    execucaoSelecionada,
    nosExecucao,
    workflowNome,
    workflowDefinicao,
    loadingLista,
    loadingDetalhe,
    error,
    selecionarExecucao,
    carregarLista,
  } = useWorkflowExecucoes(id);

  const [mostrarModalExecutar, setMostrarModalExecutar] = useState(false);
  const [expandirHistorico, setExpandirHistorico] = useState(false);
  const HISTORICO_LIMITE = 5;

  const workflowParaExecutar = id
    ? { id, nome: workflowNome, definicao: workflowDefinicao }
    : null;

  const handleConcluido = (execucaoId) => {
    setMostrarModalExecutar(false);
    carregarLista();
    selecionarExecucao(execucaoId);
  };

  return (
    <div className="exec-page">
      {/* Header */}
      <div className="exec-page-header">
        <button className="wf-btn wf-btn-secondary exec-back-btn" onClick={() => navigate('/workflows')}>
          ← Voltar
        </button>
        <div>
          <h1 className="exec-page-title">Execuções</h1>
          {workflowNome && <p className="exec-page-subtitle">{workflowNome}</p>}
        </div>
        <button className="wf-btn wf-btn-primary" onClick={() => setMostrarModalExecutar(true)}>
          ▶ Nova Execução
        </button>
      </div>

      {error && <div className="wf-error">{error}</div>}

      {/* Corpo: 2 colunas */}
      <div className="exec-page-body">
        {/* Coluna Esquerda: lista + log */}
        <div className="exec-page-left">
          <div className="exec-page-section-title">Histórico</div>
          <ExecucoesList
            execucoes={expandirHistorico ? execucoes : execucoes.slice(0, HISTORICO_LIMITE)}
            execucaoSelecionada={execucaoSelecionada}
            onSelecionar={selecionarExecucao}
            loading={loadingLista}
          />
          {!loadingLista && execucoes.length > HISTORICO_LIMITE && (
            <button
              className="exec-historico-expand-btn"
              onClick={() => setExpandirHistorico(v => !v)}
            >
              {expandirHistorico ? '▲ Ver menos' : `▼ Ver mais (${execucoes.length - HISTORICO_LIMITE} restantes)`}
            </button>
          )}

          {/* Log da execução selecionada */}
          {execucaoSelecionada && (
            <div className="exec-page-log">
              <div className="exec-page-section-title">Resultados</div>
              {loadingDetalhe ? (
                <div className="exec-list-loading">A carregar log...</div>
              ) : nosExecucao.length === 0 ? (
                <div className="exec-list-empty">Sem nós registados</div>
              ) : (
                <div className="exec-log-list">
                  {(isAdminUser
                    ? nosExecucao
                    : nosExecucao.length <= 1
                      ? nosExecucao
                      : [nosExecucao[0], nosExecucao[nosExecucao.length - 1]]
                  ).map((no, idx, arr) => {
                    const isUltimo = idx === arr.length - 1;
                    return (
                      <ExecucaoLogItem
                        key={no.id}
                        no={no}
                        defaultExpanded={!isAdminUser && isUltimo}
                        bloqueado={!isAdminUser && !isUltimo}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Coluna Direita: detalhe */}
        <div className="exec-page-right">
          <ExecucaoDetalhe
            execucao={execucaoSelecionada}
            onNovaExecucao={() => setMostrarModalExecutar(true)}
          />
        </div>
      </div>

      {/* Modal de execução */}
      {mostrarModalExecutar && workflowParaExecutar && (
        <ExecutarModal
          workflow={workflowParaExecutar}
          onFechar={() => setMostrarModalExecutar(false)}
          onConcluido={handleConcluido}
        />
      )}
    </div>
  );
}
